// libs
import React, { memo } from "react";
import { connect } from "react-redux";
import { css } from "@emotion/core";

// global components
import WithStyles from "shared/components/WithStyles";
import SubNav, { SUB_NAV_PLACEMENT } from "shared/components/SubNav";

// components
import SubMenu from "./components/SubMenu";

// redux selectors
import { isLoggedIn as _isLoggedIn, getCustomerFirstName } from "shared/store/app/selectors";

// constants
import { TEXTS } from "./constants";

//Analytics
import * as Analytics from "shared/components/Header/analytics";

// styles
const authCss = css`
    display: flex;
    min-width: 50px;
    max-width: 70px;
    justify-content: space-between;

    .ah-content {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .ah-caps {
        text-transform: capitalize;
    }

    .ah-ico {
        display: inline-block;
        margin-left: 5px;
        font-size: 0.7rem;
        transform: rotate(270deg);
    }
`;

// defs
interface IAuthProps {
    isLoggedIn: boolean;
    firstName: string;
}

function Auth({ isLoggedIn, firstName }: IAuthProps) {
    const onSubNavVisible = () => Analytics.onSignInClick();

    return (
        <>
            <SubNav
                subMenu={<SubMenu />}
                placement={SUB_NAV_PLACEMENT.RIGHT}
                onVisible={onSubNavVisible}
            >
                <WithStyles cssProps={authCss}>
                    <div className="ah-content">
                        {isLoggedIn ? (
                            <span className="ah-caps">{TEXTS.HI_USER(firstName)}</span>
                        ) : (
                            TEXTS.SIGN_IN
                        )}
                    </div>
                    <div>
                        <i className="icon-arrow ah-ico" />
                    </div>
                </WithStyles>
            </SubNav>
        </>
    );
}

const mapStateToProps = (state: any) => ({
    isLoggedIn: _isLoggedIn(state),
    firstName: getCustomerFirstName(state),
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(memo(Auth));
